(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["HEADER-PRO"] && !Shopify.designMode) return;
  try {
    
const DESKTOP_MEDIA_QUERY = '(min-width: 750px)';
const SCROLL_CONTAINER_MEDIA_QUERY = '(min-width: 990px)';
const FINE_POINTER_MEDIA_QUERY = '(hover: hover) and (pointer: fine)';
const MENU_LAYOUT_TOLERANCE = 1;
const SCROLL_DIRECTION_THRESHOLD = 2;

/**
 * Responsive Horizon header with progressive search/cart enhancement,
 * accessible drawers and disclosures, deterministic menu overflow, and
 * scroll-direction sticky behavior.
 */
class BasicHeader extends HTMLElement {
  connectedCallback() {
    this.abortController = new AbortController();
    this.signal = this.abortController.signal;

    this.bar = this.querySelector('.basic-header__bar');
    this.nav = this.querySelector('[data-header-nav]');
    this.primaryMenu = this.querySelector('[data-primary-menu]');
    this.primaryMenuItems = [...this.querySelectorAll('[data-menu-item]')];
    this.overflowMenuItems = [...this.querySelectorAll('[data-overflow-menu-item]')];
    this.moreMenuItem = this.querySelector('[data-menu-more]');
    this.moreDisclosure = this.querySelector('[data-more-disclosure]');
    this.desktopMenus = [...this.querySelectorAll('[data-desktop-menu]')];

    this.drawer = this.querySelector('[data-drawer]');
    this.drawerOpenButton = this.querySelector('[data-drawer-open]');
    this.drawerCloseButton = this.querySelector('[data-drawer-close]');
    this.sectionWrapper = this.closest('.shopify-section');

    this.desktopMedia = window.matchMedia(DESKTOP_MEDIA_QUERY);
    this.scrollContainerMedia = window.matchMedia(SCROLL_CONTAINER_MEDIA_QUERY);
    this.finePointerMedia = window.matchMedia(FINE_POINTER_MEDIA_QUERY);
    this.stickyMode = this.dataset.stickyMode || 'always';
    this.lastScrollY = 0;

    this.sectionWrapper?.setAttribute('data-sticky-mode', this.stickyMode);
    this.sectionWrapper?.removeAttribute('data-sticky-state');

    this.bindDrawer();
    this.bindHorizonEnhancements();
    this.bindDesktopMenus();
    this.bindResponsiveBehavior();
    this.bindStickyBehavior();

    this.resizeObserver = new ResizeObserver(this.onResize);
    this.resizeObserver.observe(this);

    const logo = this.querySelector('.basic-header__logo-image');
    if (logo && !logo.complete) logo.addEventListener('load', this.scheduleMenuLayout, { signal: this.signal });

    if (document.fonts?.ready) {
      document.fonts.ready.then(this.scheduleMenuLayout).catch(() => {});
    }
    this.updateHeaderMetrics();
    this.scheduleMenuLayout();
  }

  disconnectedCallback() {
    this.abortController?.abort();
    this.resizeObserver?.disconnect();
    window.cancelAnimationFrame(this.scrollFrame);
    window.cancelAnimationFrame(this.menuLayoutFrame);
    this.scrollContainer = null;
    this.scrollEventTarget = null;

    this.sectionWrapper?.removeAttribute('data-sticky-mode');
    this.sectionWrapper?.removeAttribute('data-sticky-state');

    queueMicrotask(() => {
      if (!document.querySelector('basic-header')) {
        document.body.style.removeProperty('--header-height');
        document.body.style.removeProperty('--header-group-height');
      }
    });
  }

  bindDrawer() {
    this.drawerOpenButton?.addEventListener('click', this.openDrawer, { signal: this.signal });
    this.drawerCloseButton?.addEventListener('click', this.closeDrawer, { signal: this.signal });
    this.drawer?.addEventListener('close', this.onDrawerClosed, { signal: this.signal });
    this.drawer?.addEventListener('click', this.onDrawerBackdropClick, { signal: this.signal });
  }

  bindHorizonEnhancements() {
    this.querySelector('[data-basic-search]')?.addEventListener('click', this.onSearchClick, {
      signal: this.signal,
    });
    this.querySelector('[data-basic-cart-drawer]')?.addEventListener('click', this.onCartClick, {
      signal: this.signal,
    });
  }

  bindDesktopMenus() {
    this.desktopMenus.forEach((menu) => {
      menu.addEventListener('toggle', () => this.onMenuToggle(menu), { signal: this.signal });
      menu.addEventListener('pointerenter', () => this.onMenuPointerEnter(menu), { signal: this.signal });
      menu.addEventListener('pointerleave', () => this.onMenuPointerLeave(menu), { signal: this.signal });
      menu.addEventListener('focusout', () => this.onMenuFocusOut(menu), { signal: this.signal });
    });

    this.addEventListener('keydown', this.onKeydown, { signal: this.signal });
    this.addEventListener('focusin', this.showStickyHeader, { signal: this.signal });
  }

  bindResponsiveBehavior() {
    this.desktopMedia.addEventListener('change', this.onViewportChange, { signal: this.signal });
  }

  bindStickyBehavior() {
    if (this.stickyMode !== 'scroll-up') return;

    this.setStickyState('visible');
    this.bindStickyScrollContainer();
    this.scrollContainerMedia.addEventListener('change', this.onScrollContainerChange, {
      signal: this.signal,
    });
  }

  /**
   * Horizon scrolls `.page-wrapper` at 990px and above. Smaller viewports
   * store their position on the document scroller, but mobile browsers emit
   * that scroll event on `window`. Keep the position source and event target
   * separate, then rebind both whenever the breakpoint changes.
   */
  bindStickyScrollContainer() {
    this.scrollEventTarget?.removeEventListener('scroll', this.onScroll);

    const desktopScrollContainer = document.querySelector('.page-wrapper');
    const useDesktopScrollContainer = this.scrollContainerMedia.matches && desktopScrollContainer;

    this.scrollContainer = useDesktopScrollContainer
      ? desktopScrollContainer
      : document.scrollingElement;
    this.scrollEventTarget = useDesktopScrollContainer ? desktopScrollContainer : window;

    if (this.scrollContainerMedia.matches && !desktopScrollContainer && document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', this.onDocumentReady, {
        once: true,
        signal: this.signal,
      });
    }

    this.lastScrollY = this.getScrollTop();
    this.scrollEventTarget.addEventListener('scroll', this.onScroll, {
      passive: true,
      signal: this.signal,
    });
  }

  onScrollContainerChange = () => {
    this.bindStickyScrollContainer();
    this.showStickyHeader();
  };

  onDocumentReady = () => {
    this.bindStickyScrollContainer();
  };

  getScrollTop() {
    if (this.scrollContainer instanceof Element) {
      return Math.max(this.scrollContainer.scrollTop, 0);
    }

    return Math.max(window.scrollY || document.scrollingElement?.scrollTop || 0, 0);
  }

  openDrawer = () => {
    if (!this.drawer || this.drawer.open) return;

    this.showStickyHeader();
    this.restoreFocusAfterDrawer = true;
    this.drawerOpenButton?.setAttribute('aria-expanded', 'true');

    if (typeof this.drawer.showModal === 'function') {
      this.drawer.showModal();
    } else {
      this.drawer.setAttribute('open', '');
    }

    this.drawerCloseButton?.focus({ preventScroll: true });
  };

  closeDrawer = (restoreFocus = true) => {
    if (!this.drawer?.open) return;

    this.restoreFocusAfterDrawer = Boolean(restoreFocus && this.restoreFocusAfterDrawer);

    if (typeof this.drawer.close === 'function') {
      this.drawer.close();
    } else {
      this.drawer.removeAttribute('open');
      this.onDrawerClosed();
    }
  };

  onDrawerClosed = () => {
    this.drawerOpenButton?.setAttribute('aria-expanded', 'false');

    if (this.restoreFocusAfterDrawer) {
      this.drawerOpenButton?.focus({ preventScroll: true });
      this.restoreFocusAfterDrawer = false;
    }
  };

  onDrawerBackdropClick = (event) => {
    if (event.target === this.drawer) this.closeDrawer();
  };

  /** Enhance a normal Search link only when Horizon's modal API is present. */
  onSearchClick = (event) => {
    const searchModal = document.getElementById('search-modal');

    if (typeof searchModal?.showDialog === 'function') {
      event.preventDefault();
      searchModal.showDialog();
    }
  };

  /** Enhance a normal Cart link only when Horizon's drawer API is present. */
  onCartClick = (event) => {
    const cartDrawer = document.getElementById('cart-drawer');

    if (typeof cartDrawer?.toggle === 'function') {
      event.preventDefault();
      cartDrawer.toggle();
    }
  };

  onMenuToggle = (menu) => {
    if (!menu.open) return;
    this.showStickyHeader();
    this.closeDesktopMenus(menu);
  };

  onMenuPointerEnter = (menu) => {
    if (!this.desktopMedia.matches || !this.finePointerMedia.matches || menu.closest('[hidden]')) return;
    this.showStickyHeader();
    this.closeDesktopMenus(menu);
    menu.open = true;
  };

  onMenuPointerLeave = (menu) => {
    if (!this.desktopMedia.matches || !this.finePointerMedia.matches) return;
    if (!menu.contains(document.activeElement)) menu.open = false;
  };

  onMenuFocusOut = (menu) => {
    window.requestAnimationFrame(() => {
      if (!menu.contains(document.activeElement)) menu.open = false;
    });
  };

  onKeydown = (event) => {
    if (event.key !== 'Escape' || !(event.target instanceof Element)) return;

    const openMenu = event.target.closest('[data-desktop-menu][open]');
    if (!openMenu) return;

    openMenu.open = false;
    openMenu.querySelector('summary')?.focus();
  };

  onViewportChange = (event) => {
    if (event.matches) {
      this.closeDrawer(false);
    } else {
      this.closeDesktopMenus();
      this.removeAttribute('data-menu-collapsed');
      this.resetMenuVisibility();
    }

    this.scheduleMenuLayout();
  };

  closeDesktopMenus = (exception) => {
    this.desktopMenus.forEach((menu) => {
      if (menu !== exception) menu.open = false;
    });
  };

  onResize = () => {
    this.updateHeaderMetrics();
    this.scheduleMenuLayout();
  };

  scheduleMenuLayout = () => {
    if (this.menuLayoutFrame) return;

    this.menuLayoutFrame = window.requestAnimationFrame(() => {
      this.menuLayoutFrame = 0;
      this.layoutDesktopMenu();
    });
  };

  /**
   * Keeps the primary menu in one row. Trailing items move to an accessible
   * server-rendered More menu. If even More cannot fit, the full drawer is used.
   */
  layoutDesktopMenu() {
    if (!this.desktopMedia.matches || !this.nav || !this.primaryMenu || !this.moreMenuItem) {
      this.removeAttribute('data-menu-collapsed');
      this.resetMenuVisibility();
      return;
    }

    this.setAttribute('data-menu-measuring', '');
    this.removeAttribute('data-menu-collapsed');
    this.resetMenuVisibility();

    const navWidth = Math.floor(this.nav.clientWidth);
    const menuStyle = window.getComputedStyle(this.primaryMenu);
    const gap = Number.parseFloat(menuStyle.columnGap || menuStyle.gap) || 0;
    const itemWidths = this.primaryMenuItems.map((item) => item.getBoundingClientRect().width);
    const totalItemsWidth = itemWidths.reduce((total, width) => total + width, 0);
    const totalGapsWidth = Math.max(0, this.primaryMenuItems.length - 1) * gap;

    if (totalItemsWidth + totalGapsWidth <= navWidth + MENU_LAYOUT_TOLERANCE) {
      this.finishMenuLayout(false);
      return;
    }

    this.moreMenuItem.hidden = false;
    const moreWidth = this.moreMenuItem.getBoundingClientRect().width;

    if (navWidth < moreWidth + MENU_LAYOUT_TOLERANCE) {
      this.finishMenuLayout(true);
      return;
    }

    const availableItemsWidth = Math.max(0, navWidth - moreWidth - gap);
    let usedWidth = 0;
    let visibleCount = 0;
    let overflowCount = 0;
    let overflowStarted = false;

    this.primaryMenuItems.forEach((item, index) => {
      const nextWidth = itemWidths[index] + (visibleCount > 0 ? gap : 0);
      const fits = !overflowStarted && usedWidth + nextWidth <= availableItemsWidth + MENU_LAYOUT_TOLERANCE;
      const overflowItem = this.overflowMenuItems[index];

      item.hidden = !fits;
      if (overflowItem) overflowItem.hidden = fits;

      if (fits) {
        usedWidth += nextWidth;
        visibleCount += 1;
      } else {
        overflowStarted = true;
        item.querySelector('details[open]')?.removeAttribute('open');
        overflowCount += 1;
      }
    });

    this.moreMenuItem.hidden = overflowCount === 0;
    this.finishMenuLayout(false);
  }

  resetMenuVisibility() {
    this.primaryMenuItems.forEach((item) => {
      item.hidden = false;
    });
    this.overflowMenuItems.forEach((item) => {
      item.hidden = true;
      item.querySelectorAll('details[open]').forEach((details) => details.removeAttribute('open'));
    });
    if (this.moreMenuItem) this.moreMenuItem.hidden = true;
    if (this.moreDisclosure) this.moreDisclosure.open = false;
  }

  finishMenuLayout(useDrawer) {
    this.toggleAttribute('data-menu-collapsed', useDrawer);
    this.removeAttribute('data-menu-measuring');
    if (!useDrawer && this.drawer?.open) this.closeDrawer(false);
  }

  onScroll = () => {
    if (this.scrollFrame) return;

    this.scrollFrame = window.requestAnimationFrame(() => {
      this.scrollFrame = 0;
      this.updateStickyFromScroll();
    });
  };

  updateStickyFromScroll() {
    const currentScrollY = this.getScrollTop();
    const scrollDelta = currentScrollY - this.lastScrollY;
    const headerHeight = this.getBoundingClientRect().height;

    if (currentScrollY <= headerHeight) {
      this.setStickyState('visible');
      this.lastScrollY = currentScrollY;
      return;
    }

    if (Math.abs(scrollDelta) < SCROLL_DIRECTION_THRESHOLD) return;

    if (scrollDelta < 0) {
      this.setStickyState('visible');
    } else if (this.canHideStickyHeader()) {
      this.setStickyState('hidden');
    }

    this.lastScrollY = currentScrollY;
  }

  canHideStickyHeader() {
    const hasOpenMenu = this.desktopMenus.some((menu) => menu.open);
    const hasHeaderFocus = this.contains(document.activeElement);
    return !this.drawer?.open && !hasOpenMenu && !hasHeaderFocus;
  }

  showStickyHeader = () => {
    this.setStickyState('visible');
  };

  setStickyState(state) {
    if (this.stickyMode !== 'scroll-up' || !this.sectionWrapper) return;
    if (this.sectionWrapper.dataset.stickyState === state) return;
    this.sectionWrapper.dataset.stickyState = state;
  }

  updateHeaderMetrics() {
    const headerHeight = Math.round(this.getBoundingClientRect().height);
    const headerGroup = document.getElementById('header-group');
    let headerGroupHeight = headerHeight;

    if (headerGroup) {
      headerGroupHeight = [...headerGroup.children].reduce((height, child) => {
        return height + (child instanceof HTMLElement ? child.offsetHeight : 0);
      }, 0);
    }

    document.body.style.setProperty('--header-height', `${headerHeight}px`);
    document.body.style.setProperty('--header-group-height', `${headerGroupHeight}px`);
  }
}

if (!customElements.get('basic-header')) {
  customElements.define('basic-header', BasicHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
